
import {FC} from "react";

import React from 'react';

import MLAAcceptForm from "../../forms/ppap/mla-accept-form";

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

const MLAAcceptScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <MLAAcceptForm
                    requestId={props.requestId}
                />
            
    );
}
export default MLAAcceptScreen;
